export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS'
export const ADD_CUSTOM_FIELDS = 'ADD_CUSTOM_FIELDS'
export const UPDATE_CUSTOM_FIELDS = 'UPDATE_CUSTOM_FIELDS'
export const DELETE_CUSTOM_FIELDS = 'DELETE_CUSTOM_FIELDS'
export const SET_REQUEST_STATE = 'SET_REQUEST_STATE'
